import { useQuery } from "@/api/swr/useQuery";
import { simpleAssessmentSchema } from "@/schema/console/simple-assessments/SimpleAssessment";
import { z } from "zod";

export function useGetSimpleAssessments() {
  return useQuery(
    z.array(simpleAssessmentSchema),
    "/console/assessment_papers?is_premium=false",
  );
}
